<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>历史数据</el-breadcrumb-item>
            <el-breadcrumb-item>历史列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="4">
                    <el-input style="width: 180px" placeholder="请输入水果名称" v-model="queryInfo.fruitName" clearable @clear="getProductList()">
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input style="width: 180px" placeholder="请输入用户名" v-model="queryInfo.userName" clearable @clear="getProductList()">
                    </el-input>
                </el-col>
                <el-col :span="4.5">
                    <el-input style="width: 180px" placeholder="请输入检测设备序号" v-model="queryInfo.equipmentId" clearable @clear="getProductList()">
                    </el-input>
                </el-col>
                <el-col :span="4.5">
                    <el-date-picker
                            v-model="queryInfo.time"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <!--<el-button  icon="el-icon-search" @click="getProductList()"></el-button>-->
                <el-button type="primary" icon="el-icon-search" @click="getProductList()">{{$t('common.search')}}</el-button>
            </el-row>
            <vxe-toolbar>
                <template #buttons>
                    <vxe-button @click="exportCurrDataEvent4">导出当前页</vxe-button>
                    <vxe-button @click="exportSelectEvent">导出选中</vxe-button>
                    <vxe-button @click="exportAllDataEvent4">全部导出</vxe-button>
                    <vxe-button @click="deleteList">全部删除</vxe-button>
                </template>
            </vxe-toolbar>
            <!--历史列表区域-->
            <vxe-table
                    v-loading="tableLoading"
                    border
                    show-footer
                    highlight-hover-row
                    highlight-current-row
                    ref="xTable4"
                    align="center"
                    max-height="650"
                    :data="productList.records">
                <vxe-column type="checkbox" width="60"></vxe-column>
                <vxe-column type="seq" title="序号" width="60"></vxe-column>
                <vxe-column  field="val1" title="水果名称"></vxe-column>
                <vxe-column v-if="show" field="methodParams"  title="算法用参数"></vxe-column>
                <vxe-column field="userName" title="用户名"></vxe-column>
                <!--<vxe-column field="deviceId" title="手机设备序号"></vxe-column>-->
                <vxe-column field="equipmentMac" title="设备Mac地址"></vxe-column>
                <vxe-column field="equipmentId" title="检测设备序号"></vxe-column>
                <vxe-column field="longitude" title="经度" ></vxe-column>
                <vxe-column field="latitude" title="纬度" ></vxe-column>
                <vxe-column v-if="showparm" field="params" title="设备传递参数"></vxe-column>
                <vxe-column field="temperature" title="水果表面温度" ></vxe-column>
                <vxe-column field="results" title="计算结果" ></vxe-column>
                <vxe-column field="creationTime" title="创建时间" ></vxe-column>
                <vxe-column v-if="showdelet" title="操作" width="100" show-overflow>
                    <template #default="{ row }" >
                        <!--<vxe-button type="text"  icon="fa fa-trash-o" @click="delet(row)"  >删除</vxe-button>-->
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="delet(row)"></el-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="tableData"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="productList.total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>

    export default {
        name: "RecordList",
        data() {
            return {
                show:false,
                showdelet:false,
                showparm:false,
                value1: '2020-10-01',
                tableData: [
                ],
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                    fruitName:'',
                    userId:window.sessionStorage.getItem('userId'),
                    userName:'',//用户名
                    equipmentId:'',//检测设备序号
                    time:'',
                    start:'',
                    end:''
                },
                productList: {
                    records: [],
                    total: 0
                },
                // 分类列表，用于选择父级菜单
                categoryForm: [],
                tableLoading:false
            }
        },
        created() {
            this.getProductList();
            this.getUser();
        },
        methods: {
            //导出全部数据
            async exportAllDataEvent4 () {
                let time= this.queryInfo.time.toString()
                this.queryInfo.start=time.substring(0,10)
                this.queryInfo.end=time.substring(11)
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/record/selectAll`, this.queryInfo);
                this.tableLoading = false
                setTimeout(() => {
                    this.$refs.xTable4.exportData({
                        filename: '自定义文件名',
                        type: 'csv',
                        isHeader: true,
                        isFooter: true,
                        data: res.data
                    })
                }, 100)
            },
            //删除全部历史记录
            async  deleteList(){
                // 弹框询问用户是否删除
                await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除历史记录
                    const {data: res} = await this.$http.post(`/record/removeList`, {});
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取历史
                    this.getProductList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //删除历史记录
            async  delet(row){
                // 弹框询问用户是否删除
                await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除历史记录
                    const {data: res} = await this.$http.post(`/record/removeById`, {id:row.id});
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取历史
                    this.getProductList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //导出选中
            exportSelectEvent () {
                this.$refs.xTable4.exportData({
                    data: this.$refs.xTable4.getCheckboxRecords()
                })
            },
            //导出当前表格数据
            exportCurrDataEvent4 () {
                this.$refs.xTable4.exportData({
                    filename: '自定义文件名',
                    type: 'csv',
                    isHeader: true,
                    isFooter: true
                })
            },
            //获取历史数据列表
            async getProductList() {
             let time= this.queryInfo.time.toString()
                this.queryInfo.start=time.substring(0,10)
                this.queryInfo.end=time.substring(11)
                this.tableLoading = true
                let {data: res} = await this.$http.post(`/record/selectPage`, this.queryInfo);
                this.tableLoading = false
                // if (res.code !== 1) return this.$message.error("获取历史数据！");
                this.productList.total = res.data.total;
                this.productList.records = res.data.records;
            },
            //获取用户信息
            async getUser() {
                let {data: res} = await this.$http.post(`/api/user/getById`, {'id':window.sessionStorage.getItem('userId')});
                if(res.data.setState.indexOf("3") != -1){
                    this.show=true
                }
                if(res.data.setState.indexOf("4") != -1){
                    this.showdelet=true
                }
                if(res.data.setState.indexOf("5") != -1){
                    this.showparm=true
                }
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getProductList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getProductList()
            },
            // 导出数据
            excel() {

            }
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }
    .app .el-card {
        width: 99%;
    }
</style>
